export default __webpack_public_path__ + "static/media/band9.9f1c47b2.jfif";